module.exports = __webpack_public_path__ + "img/result-detail-last-message-title.cb2a8e65.svg";